module.exports = __webpack_public_path__ + "static/media/applications.efe3ca34.svg";